import React from "react"
import "./workAbout.css"

export default props => {
  return (
    <div id="workAbout-holder">
      <div id="workAbout-left">
        <h3 id="title">{props.title}</h3>
        <p id="first">{props.p1}</p>
        <p id="second">{props.p2}</p>
      </div>
      <div id="workAbout-right">
        <img src={props.logo} alt="company-logo" />
      </div>
    </div>
  )
}
